import React from "react";
import './index.css'
import SoccerField from "./components/Field";
import TeamsSelector from "./components/TeamsSelector";
import { useGetLineUps } from "./hooks/useGetLineUps";

const FieldLineUp = ()=>{
   const { teams,handleSetLocalOrVisitor } = useGetLineUps()
    return(
    <div className="fieldLineUp-container">
        <div>
            <TeamsSelector selectTeam={handleSetLocalOrVisitor} teams={teams} />
            <SoccerField teams={teams} />
        </div>
    </div>
    )
}

export default FieldLineUp;